import {TextField} from '@mui/material';
import {Col, Row} from 'antd';
import {ConversionFormDetails} from '../conversionType';
import {DataIndexItem} from '../../../../types/interfaces';
import { useEffect, useState } from 'react';

interface ConversionDetailsProps {
    selectedConversionDetails: ConversionFormDetails;
    setSelectedConversionDetails: React.Dispatch<React.SetStateAction<ConversionFormDetails>>;
    data: DataIndexItem;
}

const AdvanceMenuDetails: React.FC<ConversionDetailsProps> = ({
    selectedConversionDetails,
    setSelectedConversionDetails,
    data
}) => {

    const [isChecked3, setIsChecked3] = useState(selectedConversionDetails.force_pdal);

    const handleProjectPipelineChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = e.target.value;
        setSelectedConversionDetails(prevState => ({
            ...prevState,
            proj_pipeline: newValue
        }));
    };

    const handleToggleChange3 = () => {
        const newValue = !isChecked3;
        setIsChecked3(newValue);
        setSelectedConversionDetails(prevState => ({
            ...prevState,
            force_pdal: newValue
        }));
    };

    // useEffect(() => {
    //     console.log(selectedConversionDetails,'-----------');
    //     setSelectedConversionDetails(
    //         {
    //             ...selectedConversionDetails,
    //             proj_pipeline: data.params?.proj_pipeline || ''
    //         }
    //     )
    // }, [])

    const locked = data.locked
    const classNameString = locked ? 'cursor_drop' : ''
    return (
        <>

            <Row gutter={[16, 16]} className='panel_row switch_container'>
                <Col span={12}>
                    <label>Force PDAL Step.</label>
                </Col>
                <Col span={12}>
                    <div className="toggle-wrapper">
                        <input id="switch3"
                               className="toggle"
                               type="checkbox"
                               checked={isChecked3}
                               onChange={handleToggleChange3}/>
                        <label htmlFor="switch3" className="toggle--label"></label>
                        <div className="foux-toggle"></div>
                    </div>
                </Col>

            </Row>
            <Row gutter={[16, 16]} className='panel_row'>
                <Col span={12}>
                    <TextField
                        label="Project Pipe Line"
                        value={selectedConversionDetails.proj_pipeline || ''}
                        onChange={handleProjectPipelineChange} //
                        InputLabelProps={{shrink: true}}
                        fullWidth
                        disabled={locked}
                        className={classNameString}
                    />
                </Col>
                <Col span={12}>

                </Col>
            </Row>
        </>
    );
}

export default AdvanceMenuDetails;
